import React from 'react';
import styled from 'styled-components';
import { Container, Title, BrandText } from '../../../styles/components';
import { Logo } from '../../Logo';
import { colors, typography } from '../../../styles/theme/index';

const PageWrapper = styled(Container)`
  background-color: #f1f7f3;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;

  @media screen and (max-width: 480px) {
    background-color: #ffffff;
    padding: 0;
  }
`;

const WhiteContainer = styled.div`
  background: white;
  border-radius: 24px;
  padding: 20px;
  width: 90%;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  box-sizing: border-box;

  @media screen and (max-width: 480px) {
    width: 100%;
    border-radius: 0;
    padding: 16px;
    min-height: 100vh;
  }
`;

const TopLeftLogo = styled.div`
  position: absolute;
  top: 30px;
  left: 30px;
  opacity: 1;
  transform: scale(0.8);

  @media screen and (max-width: 480px) {
    position: static;
    margin: 10px auto;
    transform: scale(0.7);
  }
`;

const StyledTitle = styled(Title)`
  text-align: center;
  margin: 80px 0 40px;
  padding-top: 20px;
  width: 100%;

  @media screen and (max-width: 768px) {
    font-size: 1.5rem;
  }

  @media screen and (max-width: 480px) {
    margin: 10px 0 20px;
    padding-top: 0;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 120px;
  flex: 1;

  @media screen and (max-width: 480px) {
    padding-bottom: 80px;
  }
`;

const BackButton = styled.button`
  position: absolute;
  bottom: 80px;
  left: 50px;
  background: none;
  border: none;
  color: ${colors.text.secondary};
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.sm};
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0;

  @media screen and (max-width: 480px) {
    position: static;
    margin: 20px auto;
  }

  &:hover {
    color: ${colors.primary};
  }
`;

const Disclosure = styled.div`
  position: absolute;
  bottom: 30px;
  left: 50%;
  transform: translateX(-50%);
  font-family: ${typography.fontFamily};
  font-size: ${typography.fontSize.sm};
  color: ${colors.text.secondary};
  text-align: center;
  line-height: 1.2;

  a {
    color: inherit;
    text-decoration: underline;
  }

  @media screen and (max-width: 480px) {
    position: relative;
    bottom: auto;
    margin-top: 80px;
  }
`;

const OnboardingLayout = ({ 
  children, 
  title, 
  brandText, 
  onBack,
  showBackButton = true 
}) => {
  return (
    <PageWrapper>
      <WhiteContainer>
        <TopLeftLogo>
          <Logo />
        </TopLeftLogo>

        {title && (
          <StyledTitle>
            {title} {brandText && <BrandText>{brandText}</BrandText>}
          </StyledTitle>
        )}

        <ContentContainer>
          {children}
        </ContentContainer>

        {showBackButton && onBack && (
          <BackButton onClick={onBack}>← Back</BackButton>
        )}
        <Disclosure>
          By using this service you are agreeing to Planet Protection's <a href="/assets/Planet_Protection_TOBA.pdf" target="_blank" rel="noopener noreferrer">terms of business</a>.
        </Disclosure>
      </WhiteContainer>
    </PageWrapper>
  );
};

export default OnboardingLayout; 